import { hasUsableCoordinates } from "@/helpers/mapbox";

// Inventory-only: MapBoxComponent swaps a zero lat or lng for its Phoenix
// default, so a 0 placeholder would show a pin in the wrong city.
export const hasInventoryMapLocation = (lng, lat) =>
  hasUsableCoordinates(lng, lat) && Number(lng) !== 0 && Number(lat) !== 0;
